/* ==========================================================================
   TRIDOO — Fasce editoriali: la fila di prodotti che scorre
   --------------------------------------------------------------------------
   La fila si scorre da sola, col dito o con la rotella: qui ci sono solo le
   frecce per chi usa il computer. Spostano la fila di una schermata, si
   spengono agli estremi e spariscono se la fila sta tutta in vista. Senza
   JavaScript le frecce restano nascoste e la fila funziona lo stesso.
   ========================================================================== */
if (!customElements.get('ted-fila')) {
  customElements.define('ted-fila', class extends HTMLElement {
    connectedCallback() {
      this.binario = this.querySelector('[data-ted-binario]');
      this.frecce = Array.from(this.querySelectorAll('[data-ted-verso]'));
      if (!this.binario || this.frecce.length === 0) return;

      this.aggiorna = this.aggiorna.bind(this);
      this.frecce.forEach((freccia) => {
        freccia.addEventListener('click', () => {
          const calmo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.binario.scrollBy({
            left: Number(freccia.dataset.tedVerso) * this.binario.clientWidth,
            behavior: calmo ? 'auto' : 'smooth',
          });
        });
      });
      this.binario.addEventListener('scroll', () => requestAnimationFrame(this.aggiorna), { passive: true });
      this.osservatore = new ResizeObserver(this.aggiorna);
      this.osservatore.observe(this.binario);
      this.aggiorna();
    }

    disconnectedCallback() {
      if (this.osservatore) this.osservatore.disconnect();
    }

    aggiorna() {
      const b = this.binario;
      const fine = b.scrollWidth - b.clientWidth;
      const scorre = fine > 2;
      this.frecce.forEach((freccia) => {
        freccia.hidden = !scorre;
        freccia.disabled = Number(freccia.dataset.tedVerso) < 0 ? b.scrollLeft <= 2 : b.scrollLeft >= fine - 2;
      });
    }
  });
}
